<template>
    <div>
        <form @submit.prevent="submitPromoInfo">
            <div class="row mb-3">
                <div class="col-sm-12" :class="isEdit ? 'col-md-7' : 'col-md-12'">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.outlet')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0" :style="isEdit ? 'opacity: 0.5' : ''">
                                    <i class="fas fa-store"></i>
                                </label>
                                <multiselect :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="selectOutlet" :disabled="isEdit ? true: false">
                                    <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="" @keyup="titleValidation">
                        </div>
                        <div id="err" class="error-validation"></div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.start_redeem_date')}}</label>
                                <date-range-picker class="w-100"
                                    ref="picker"
                                    v-model="startDate"
                                    :dateFormat="dateFormat"
                                    :opens="'right'"
                                    :ranges="false"
                                    :autoApply="true"
                                    :showDropdowns="true" 
                                    :always-show-calendars="true"
                                    :single-date-picker="true"
                                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}">
                                </date-range-picker>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.end_redeem_date')}}</label>
                                <date-range-picker class="w-100"
                                    ref="picker"
                                    v-model="endDate"
                                    :dateFormat="endDateFormat"
                                    :opens="'right'"
                                    :ranges="false"
                                    :autoApply="true"
                                    :showDropdowns="true" 
                                    :always-show-calendars="true"
                                    :single-date-picker="true"
                                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                                    @update="setExpiryDate">
                                </date-range-picker>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.expiry_date')}}</label>
                                <date-range-picker class="w-100"
                                    ref="picker"
                                    v-model="expiryDate"
                                    :dateFormat="expiryDateFormat"
                                    :opens="'right'"
                                    :ranges="false"
                                    :autoApply="true"
                                    :showDropdowns="true" 
                                    :always-show-calendars="true"
                                    :single-date-picker="true"
                                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}">
                                </date-range-picker>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.expiry_day')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-calendar-exclamation"></i>
                                        </span>
                                    </div>
                                    <input class="form-control pl-3" type="number" :placeholder="$t('label.expiry_day')" 
                                    v-model="expiryDay" 
                                    :min="0" :max="1000" 
                                    @keypress="isNumber($event)"
                                    required/>
                                </div>
                                <div id="errExpDay" class="error-validation"></div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isEdit" class="form-group">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="rewardEnable" v-model="enable">
                            <label class="custom-control-label" for="rewardEnable">{{$t('label.enable')}}</label>
                        </div>
                    </div>
                </div>
                <div v-if="isEdit" class="col-sm-12 col-md-5 pt-3 border-left text-center">
                    <qrcode v-if="qrCode != ''" :value="qrCode" :options="{ width: 150 }"></qrcode>
                    <a class="link qrDetails" @click="copyQRCode($event)">
                        <span class="qr-link text-wrap badge border border-primary text-primary fw-400">{{qrCode}}</span>
                        <input type="hidden" :value="qrCode"/>
                    </a>
                    <span style="display: none;" class="mt-3 badge badge-success"><i class="fas fa-check mr-1"></i>{{$t('label.qr_code_copied')}}</span>
                </div>
            </div>
            <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnRewardList">{{$t('button_link.cancel')}}</button>
            <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.next')}}</button>
        </form>
    </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import {convertDateToString, isNumber} from './../../../../assets/js/dashboard/utilities'
import {getOutletName} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "rewardFormInfo",
    components:{
        DateRangePicker
    },
    props: {
        isEdit: { type: Boolean },
    },
    data(){
        let now = new Date();
        let startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var endDate = new Date(startDate);
        endDate.setDate(endDate.getDate()+ 7)
        return{
            outlet: [], selectedOutlet: {},
            title: "",
            startDate: { startDate: startDate, endDate: startDate }, endDate: { startDate: endDate, endDate: endDate }, 
            expiryDate: { startDate: endDate, endDate: endDate }, expiryDay: 0,
            enable: true, qrCode: ""
        }
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        dateFormat (classes, date) {
            if (!classes.disabled) {
                var now = new Date()
                var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                classes.disabled = date < today
            }
            return classes
        }, 
        endDateFormat (classes, date) {
            if (!classes.disabled) {
                classes.disabled = date < this.startDate.startDate
            }
            return classes
        }, 
        expiryDateFormat(classes, date){
            classes.disabled = date < this.startDate.startDate 
            if(!classes.disabled){
                var endDate = this.endDate.startDate
                var newEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1);
                classes.disabled = date < newEndDate
            }
            return classes
        },
        titleValidation(){
            var strError = null;
            if(this.title == "") {
                strError = this.$i18n.t('message.error.reward.title_empty')
            }else if(this.title.length < 5){
                strError = this.$i18n.t('message.error.reward.title_min_length')
            }
            document.getElementById('err').innerHTML = strError;
        },  
        selectOutlet(item){
            this.selectedOutlet = item;
        },
        setExpiryDate(date){
            var newExpDate = new Date(date.startDate.getFullYear(), date.startDate.getMonth(), date.startDate.getDate() + 1);
            this.expiryDate = {startDate: newExpDate, endDate: newExpDate};
            this.expiryDay = this.calculateExpiryDay();

            document.getElementById('errExpDay').innerHTML = null;
        },
        updateExpiryDate(e){
            var expiryDay = parseInt(e.target.value)

            var strDate = this.rearrangeDateFormat(this.startDate.startDate)
            var endDate = new Date(strDate)
            endDate.setDate(endDate.getDate()+ expiryDay)

            this.expiryDay = expiryDay;

            var expiryDate = {startDate: endDate, endDate: endDate}
            this.expiryDay = expiryDay;
            this.expiryDate = expiryDate
            if(expiryDate.startDate < this.endDate.startDate){
                document.getElementById('errExpDay').innerHTML = this.$i18n.t('message.error.reward.expiry_date');
            }else{
                document.getElementById('errExpDay').innerHTML = null;
                this.expiryDay = expiryDay;
                this.expiryDate = expiryDate
            }
        },
        calculateExpiryDay(){
            var difference = this.expiryDate.startDate - this.startDate.startDate;
            return Math.round(difference/((1000 * 3600 * 24)))
        },
        submitPromoInfo(){
            if(document.getElementById('errExpDay').innerHTML == '' || document.getElementById('errExpDay').innerHTML == null){
                var data = {
                    outlet: this.selectedOutlet,
                    title: this.title,
                    startDate: this.rearrangeDateFormat(this.startDate.startDate),
                    endDate: this.rearrangeDateFormat(this.endDate.startDate),
                    expiryDate: this.rearrangeDateFormat(this.expiryDate.startDate),
                    expiryDay: this.expiryDay
                }
                if(this.isEdit){
                    data["isEnable"] = this.enable ? 1 : 0
                }
                this.$emit('submitPromoInfo', data, 1)
            }
            
        },
        rearrangeDateFormat(date){
            var strDate = convertDateToString(date)
            var arrDate = strDate.split('/')
            return arrDate[2] + '/' + arrDate[1] + '/' + arrDate[0]
        },
        returnRewardList(){
            this.$emit('returnRewardList', this.selectedOutlet)
        },
        editReward(data){
            this.selectedOutlet = {id: data.outletID, text: getOutletName(data.outletID, this.outlet)};
            this.title = data.title
            var startDate = new Date(data.startDate)
            var endDate = new Date(data.endDate)
            var expiryDate = new Date(data.expiryDate)
            this.startDate = {
                startDate: startDate, endDate: startDate
            }
            this.endDate = {
                startDate: endDate, endDate: endDate
            }
            this.expiryDate = {
                startDate: expiryDate, endDate: expiryDate
            }

            this.expiryDay = data.expiryDay
            this.isEnable = data.isEnable == 1 ? true : false;
            this.qrCode = data.qrcode
        },
        copyQRCode(e){
            var input = e.target.nextSibling
            input.select();
            document.execCommand("copy");

            var isQRCopy = e.target.parentElement.nextSibling
            isQRCopy.style.display = isQRCopy.style.display == 'none' ? 'inline-block' : 'none';

            setTimeout(() => { isQRCopy.style.display = 'none'; }, 2000); 
        },
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.expiryDay = $vm.calculateExpiryDay()
    }
}
</script>
<style scoped>
.qr-link:hover{
    color: #ffffff !important;
    background: #b19dce !important;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>